/**
 * Por onde a assinatura pode ser cobrada. Modulo puro: so decide.
 *
 * DENTRO DO APP DAS LOJAS, NUNCA PELO CARTAO DIRETO. Cobrar conteudo digital
 * fora da loja e violacao da guideline 3.1.1 da Apple, e isso ja aconteceu de
 * verdade: `platform/billing.disponivel()` exige a chave publica do RevenueCat,
 * o build iOS estava sem `REACT_APP_REVENUECAT_IOS`, e com a chave vazia a tela
 * caia no formulario de cartao do pagar.me — dentro do binario submetido.
 *
 * Uma variavel de ambiente esquecida nao pode transformar o app num app que
 * cobra por fora. Por isso isto e uma funcao com nome e teste, e nao um
 * `!naLoja` solto no meio do JSX.
 */

/**
 * @param {{ nativo?: boolean, lojaDisponivel?: boolean }} contexto
 * @returns {'loja'|'web'|'indisponivel'}
 */
export function caminhoDeCobranca({ nativo = false, lojaDisponivel = false } = {}) {
  if (!nativo) return 'web';
  return lojaDisponivel ? 'loja' : 'indisponivel';
}


/**
 * Da para pedir dinheiro direto aqui? (cartao, PIX, boleto — qualquer forma.)
 *
 * A 3.1.1 NAO fala so da tela de assinar: vale para todo o binario. A revisao de
 * 25/08/2026 achou duas cobrancas fora dela — "Atualizar cartao" nas
 * Configuracoes e o "Pagar" por PIX no historico de faturas. Cada tela tinha
 * decidido sozinha, e duas decidiram errado.
 *
 * Por isso existe este nome: quem for criar a terceira tela de cobranca
 * pergunta aqui em vez de reinventar a regra.
 *
 * Loja indisponivel NAO libera cobrar por fora — libera avisar e parar.
 */
export function podeColetarPagamento(contexto) {
  return caminhoDeCobranca(contexto) === 'web';
}
